import { render, staticRenderFns } from "./Dateselector.vue?vue&type=template&id=245b5fb8&scoped=true&"
import script from "./Dateselector.vue?vue&type=script&lang=js&"
export * from "./Dateselector.vue?vue&type=script&lang=js&"
import style0 from "./Dateselector.vue?vue&type=style&index=0&id=245b5fb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../PatientEnrollment/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245b5fb8",
  null
  
)

export default component.exports